import {useEffect} from 'react';
import {useAppSelector} from 'store/hooks';
import GuestRoutes from './routes/guest/guest.routes';
import {AuthenticatedRoutes} from './routes';
import {BrowserRouter} from 'react-router-dom';

function AppNavigator() {
  const {isLoggedIn} = useAppSelector((state) => state.login);

  useEffect(() => {}, [isLoggedIn]);
  return (
    <BrowserRouter basename="/michael-waheeb-pharmacy">
      {isLoggedIn ? <AuthenticatedRoutes /> : <GuestRoutes />}
    </BrowserRouter>
  );
}

export default AppNavigator;
